<template>
  <div>
    
    <section class="tw-relative tw-w-full tw-h-[60vh] overflow-hidden">
      <neuron-google-map-v2
        v-if="allMaps.length"
        v-model:markers="allMaps"
        :center="defaultCenter"
        :markerImg="allMaps[0].marker"
        class="tw-absolute tw-inset-0 tw-w-full tw-h-full"
      />
    </section>

    
    <section
      class="tw-relative tw-z-20 tw--mt-8 md:tw--mt-12 tw-px-4 tw-pb-12"
     >
    
      <div
    class="tw-max-w-2xl tw-mx-auto tw-shadow-lg tw-p-6 tw-bg-white md:tw-p-10"
    :class="`tw-bg-[var(--c-${vars.backgroundColor})]`"
  >
        <h1
          v-if="vars.titleText"
          class="tw-text-center tw-text-2xl md:tw-text-3xl tw-mb-6 tw-text-[var(--c-primary)]"
        >
          {{ vars.titleText }}
        </h1>
        <library-form
          v-if="form"
          :form="form"
          version="v2"
          :component="component"
          :is-form-name-visible="vars.isFormNameVisibleBool"
        />
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import NeuronGoogleMapV2 from '~/components/common/NeuronGoogleMapV2.vue';

export default defineNuxtComponent({
  name: 'BranchesContact',
  mixins: [ComponentMixin],
  components: { NeuronGoogleMapV2 },

  computed: {
    allMaps() {
      return this.groupedVariables.locations;
    },
    defaultCenter() {
      return this.allMaps[0] || { lat: 0, lng: 0, marker: '' };
    },
  },
});
</script>
